import { useAccordionButton } from "react-bootstrap";
import Icons from "../../utils/components/icons";

export default function CustomToggle({ children, eventKey, onClick, isOpen }) {
  const decoratedOnClick = useAccordionButton(eventKey, (e) => {
    if (onClick) onClick(e);
  });

  return (
    <div className="cstm-header" id={`${eventKey}`}>
      {children}{" "}
      <span onClick={decoratedOnClick}>
        {isOpen ? Icons.expandAccordion : Icons.collapseAccordion}
      </span>
    </div>
  );
}
